<template>
<div class="event-item">
  <a class="event-item__link" :href="event.url">
    <div class="event-item__content">
      <div class="event-item__media">
       <img
            class="event-item__image"
            :srcset="`${imageUrl(event, {width: 300, height: 169 }, {focalX: event.image.focalX, focalY: event.image.focalY})} 300w, ${imageUrl(event, {width: 640, height: 360 }, {focalX: event.image.focalX, focalY: event.image.focalY})} 640w, ${imageUrl(event, {width: 1280, height: 720 }, {focalX: event.image.focalX, focalY: event.image.focalY})} 1280w`"
            :src="`${imageUrl(event, {width: 300, height: 169 })}`"
            width="1200"
            height="720"
            v-if="event.image"
            v-cloak
        />
      </div>

      <div class="event-item__details">
        <span v-if="event.prefix" class="event-item__prefix">{{ event.prefix }}</span>

        <h3 class="event-item__titles" :aria-label="event.title">
          <span class="event-item__title" aria-hidden="true">
            {{ event.title }}
          </span>
        </h3>
        <div class="event-item__footer">
          <p class="event-item__date">
            {{ formattedDate }}
          </p>
          <p v-if="event.tessitura && event.tessitura.data && event.tessitura.data.Facility && event.tessitura.data.Facility.Description" class="event-item__location">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true" class="event-pin icon-location-pin" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_55408_1401)">
                <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM7 9C7 6.24 9.24 4 12 4C14.76 4 17 6.24 17 9C17 11.88 14.12 16.19 12 18.88C9.92 16.21 7 11.85 7 9Z" fill="black"/>
                <path d="M12 11.5C13.3807 11.5 14.5 10.3807 14.5 9C14.5 7.61929 13.3807 6.5 12 6.5C10.6193 6.5 9.5 7.61929 9.5 9C9.5 10.3807 10.6193 11.5 12 11.5Z" fill="black"/>
              </g>
              <defs>
                <clipPath id="clip0_55408_1401">
                  <rect width="24" height="24" fill="white"/>
                </clipPath>
              </defs>
            </svg>
            <span>{{ event.tessitura.data.Facility.Description }}</span>
          </p>
        </div>
      </div>
    </div>
  </a>
  <favorite-button class="event-item__heart" :data="event.tessitura" />
</div>
</template>

<script>
import { inject } from 'vue';
import zonedDate from '../utils/zoned-date';
import dateRange from '../utils/date-range';

const now = zonedDate();

export default {
  name: 'WhatsOnEvent',
  props: {
    event: {
      type: Object,
      required: true,
    }
  },
  setup(props) {
    const imageUrl = inject('imageUrl');

    return {
        imageUrl: imageUrl
    }
  },
  computed: {
        formattedDate() {
        const start = this.event.startDateLocal || this.event.startDate;
        const end = this.event.endDateLocal || this.event.endDate;
        return dateRange(new Date(start), end ? new Date(end) : null);
    },
  }
};
</script>
